export const isNotNull = <T>(x: T | null): x is T => !!x

export default isNotNull
